import { useState, useEffect, useRef } from "react";
import "./ShutterToggle.scss";

const ShutterToggle = () => {
    const [isOn, setIsOn] = useState(false);

    useEffect(() => {
        setIsOn(false);
    }, [window.selectedConfig.currentSelectedMenu, window.selectedConfig.currentSelectedHotspot]); // or currentSelectedSubmenu

    const handleToggle = () => {
        const nextState = !isOn;

        if (window.scene) {
            const sequenceName = nextState ? "startOpenShutterAnimation" : "startCloseShutterAnimation";

            window.scene.applySequence(window[sequenceName]);
        }

        setIsOn(nextState);
    };

    return (
        <div className="shutterToggle" onClick={(e) => e.stopPropagation()}>
             <div className="toggleLabel">
                Privacy shutter
            </div>
            <div
                className={`toggleTrack ${isOn ? "on" : "off"}`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-checked={isOn}
                aria-label="Privacy shutter toggle"
                onKeyDown={(e) => e.key === "Enter" && handleToggle()}
            >
                <div className="toggleInnerPill">
                    <span className="toggleText">{isOn ? "ON" : "OFF"}</span>
                    <div className="toggleKnob"></div>
                </div>
            </div>
        </div>
    );
};

export default ShutterToggle;